// export const BASE_URL = 'http://localhost:7777/api/v1/';

export const BASE_URL = 'https://api.quadprosoft.com/qps-admin/api/v1/';


export const REGISTER = "auth/register/user";
export const LOGIN="auth/login";
export const EMAIL_VERIFY = "email/verify/";
export const LOGIN_EMAIL_VERIFY = "email";
export const CONTACT_VERIFY = "contactverify/sendotp";
export const CONTACT_SUBMIT = "contactverify";
export const CONTACT = "contact";

export const CAREERS = "career"
export const FORGOT_PASSWORD ='forgotpassword'

export const CHANGE_PASSWORD ='forgotpassword/changepassword'
